import CaptivateCardImg from './ImageOrientation/CaptivateCardImg';
import CaptivatePotraitImg from './ImageOrientation/CaptivatePotraitImg';

import * as S from './CaptivativeImagesGrid.styles';

const CaptivateImageGridFour = ({dataList, variation = 1, updateCarouselState = imageNo => {}}) => {
  if (dataList.length !== 4) return null;

  const renderImage = (Component, data, index) => (
    <Component
      imgUrl={data?.url}
      thumbnailUrl={data?.thumbnailURL}
      updateCarouselState={updateCarouselState}
      imageNo={data?.imageNo || index}
      isVideo={data?.mediaType === 'VIDEO'}
    />
  );

  const renderGrid = indexes => (
    <S.CaptivateImageGridContainer>
      <S.CaptivateImageGridInnerWrap>
        {renderImage(CaptivateCardImg, dataList[indexes[0]], indexes[0])}
        {renderImage(CaptivatePotraitImg, dataList[indexes[1]], indexes[1])}
      </S.CaptivateImageGridInnerWrap>
      <S.CaptivateImageGridInnerWrap>
        {renderImage(CaptivatePotraitImg, dataList[indexes[2]], indexes[2])}
        {renderImage(CaptivateCardImg, dataList[indexes[3]], indexes[3])}
      </S.CaptivateImageGridInnerWrap>
    </S.CaptivateImageGridContainer>
  );

  return <>{variation % 2 !== 0 ? renderGrid([0, 1, 2, 3]) : renderGrid([2, 3, 0, 1])}</>;
};

export default CaptivateImageGridFour;
